<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'app'
}
</script>
<style>
@font-face {
  font-family: 'st-font';
  src: url('https://wx-love-img.afunapp.com/songti.ttf');
}
</style>